import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination])

export function sliderImages() {
  new Swiper('.slider--images', {
    slidesPerView: 'auto',
    freeMode: true,
    navigation: {
      nextEl: '.slider__next',
      prevEl: '.slider__prev',
    },
  });
}

export function sliderWines() {
  new Swiper('.slider--wines', {
    slidesPerView: 'auto',
    freeMode: true,
    navigation: {
      nextEl: '.slider__next',
      prevEl: '.slider__prev',
    },
  });
}
